'use strict';

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncGeneratorDelegate = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; for ("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;) { if (async && null != (method = iterable[async])) return method.call(iterable); if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable)); async = "@@asyncIterator", sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object.")); var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s, this.n = s.next; }, AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; return void 0 === ret ? Promise.resolve({ value: value, done: !0 }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }, new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var errCode = require('err-code');

var browserStreamToIt = require('browser-readablestream-to-it');

var itPeekable = require('it-peekable');

var map = require('it-map');

var utils = require('./utils.js');

var ipfsUnixfs = require('ipfs-unixfs');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var browserStreamToIt__default = /*#__PURE__*/_interopDefaultLegacy(browserStreamToIt);

var itPeekable__default = /*#__PURE__*/_interopDefaultLegacy(itPeekable);

var map__default = /*#__PURE__*/_interopDefaultLegacy(map);

function normaliseCandidateMultiple(_x, _x2) {
  return _normaliseCandidateMultiple.apply(this, arguments);
}

function _normaliseCandidateMultiple() {
  _normaliseCandidateMultiple = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input, normaliseContent) {
    var peekable, _yield$_awaitAsyncGen, value, done;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof input === 'string' || input instanceof String || utils.isBytes(input) || utils.isBlob(input) || input._readableState)) {
              _context.next = 2;
              break;
            }

            throw errCode__default["default"](new Error('Unexpected input: single item passed - if you are using ipfs.addAll, please use ipfs.add instead'), 'ERR_UNEXPECTED_INPUT');

          case 2:
            if (utils.isReadableStream(input)) {
              input = browserStreamToIt__default["default"](input);
            }

            if (!(Symbol.iterator in input || Symbol.asyncIterator in input)) {
              _context.next = 26;
              break;
            }

            peekable = itPeekable__default["default"](input);
            _context.next = 7;
            return _awaitAsyncGenerator(peekable.peek());

          case 7:
            _yield$_awaitAsyncGen = _context.sent;
            value = _yield$_awaitAsyncGen.value;
            done = _yield$_awaitAsyncGen.done;

            if (!done) {
              _context.next = 13;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator([]), _awaitAsyncGenerator), "t0", 12);

          case 12:
            return _context.abrupt("return");

          case 13:
            peekable.push(value);

            if (!Number.isInteger(value)) {
              _context.next = 16;
              break;
            }

            throw errCode__default["default"](new Error('Unexpected input: single item passed - if you are using ipfs.addAll, please use ipfs.add instead'), 'ERR_UNEXPECTED_INPUT');

          case 16:
            if (!value._readableState) {
              _context.next = 19;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map__default["default"](peekable, function (value) {
              return toFileObject({
                content: value
              }, normaliseContent);
            })), _awaitAsyncGenerator), "t1", 18);

          case 18:
            return _context.abrupt("return");

          case 19:
            if (!utils.isBytes(value)) {
              _context.next = 23;
              break;
            }

            _context.next = 22;
            return toFileObject({
              content: peekable
            }, normaliseContent);

          case 22:
            return _context.abrupt("return");

          case 23:
            if (!(utils.isFileObject(value) || value[Symbol.iterator] || value[Symbol.asyncIterator] || utils.isReadableStream(value) || utils.isBlob(value))) {
              _context.next = 26;
              break;
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(map__default["default"](peekable, function (value) {
              return toFileObject(value, normaliseContent);
            })), _awaitAsyncGenerator), "t2", 25);

          case 25:
            return _context.abrupt("return");

          case 26:
            if (!utils.isFileObject(input)) {
              _context.next = 28;
              break;
            }

            throw errCode__default["default"](new Error('Unexpected input: single item passed - if you are using ipfs.addAll, please use ipfs.add instead'), 'ERR_UNEXPECTED_INPUT');

          case 28:
            throw errCode__default["default"](new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

          case 29:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _normaliseCandidateMultiple.apply(this, arguments);
}

function toFileObject(_x3, _x4) {
  return _toFileObject.apply(this, arguments);
}

function _toFileObject() {
  _toFileObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input, normaliseContent) {
    var path, mode, mtime, content, file;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            path = input.path, mode = input.mode, mtime = input.mtime, content = input.content;
            file = {
              path: path || '',
              mode: ipfsUnixfs.parseMode(mode),
              mtime: ipfsUnixfs.parseMtime(mtime)
            };

            if (!content) {
              _context2.next = 8;
              break;
            }

            _context2.next = 5;
            return normaliseContent(content);

          case 5:
            file.content = _context2.sent;
            _context2.next = 12;
            break;

          case 8:
            if (path) {
              _context2.next = 12;
              break;
            }

            _context2.next = 11;
            return normaliseContent(input);

          case 11:
            file.content = _context2.sent;

          case 12:
            return _context2.abrupt("return", file);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _toFileObject.apply(this, arguments);
}

exports.normaliseCandidateMultiple = normaliseCandidateMultiple;